import {FILE_REQUEST_ROUTE_SEGMENT} from "attribution/adAttribution";

/**
 * Who answers a file request on its upload page (kitecorp/transferify-ui#3140): the contact an emailed
 * request's link was made for, or anyone holding a request's shared link. React-free.
 */
export type RequestUploader = {kind: "contact"; contactId: string} | {kind: "link"};

/**
 * An emailed request's link carries the contact it was sent to; a shared link carries only the request,
 * so a page opened without a contact is answering a shared link.
 */
export function requestUploaderOf(contactId: string | undefined): RequestUploader {
	return contactId ? {kind: "contact", contactId} : {kind: "link"};
}

/**
 * The api route an upload to a request starts at. The api names the uploader in the path: the contact for
 * an emailed request, or the literal `link` for a shared one, whose uploader is whoever is signed in.
 */
export function requestUploadPath(reminderId: string, uploader: RequestUploader): string {
	const who = uploader.kind === "contact" ? uploader.contactId : "link";
	return `/${FILE_REQUEST_ROUTE_SEGMENT}/${reminderId}/${who}/uploads`;
}

/**
 * Whether this page may take an answer: a contact answers the request they were sent, while a page opened
 * without a contact answers only a request shared as a link. An emailed request reached without its
 * contact has no one to file the answer under, so the page says it is unavailable instead.
 */
export function uploaderCanAnswer(uploader: RequestUploader, linkRequest: boolean): boolean {
	return uploader.kind === "contact" || linkRequest;
}
